module.exports = __webpack_public_path__ + "static/img/1-0.4ecfe43.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/aboutUs/1-0.png
// module id = pcst
// module chunks = 15